import type { IntlShape } from "@formatjs/intl";
import { Form, Select } from "antd";
import { CategoryEnum } from "../../generated-axios-client";

type CategorySelectorFormItemProps = {
  intl: IntlShape;
};

export const CategorySelectorFormItem = ({ intl }: CategorySelectorFormItemProps) => (
  <Form.Item name="category" label={intl.formatMessage({ id: "material_category" })}>
    <Select
      allowClear
      options={[
        {
          label: intl.formatMessage({ id: "material_category_chemicals" }),
          value: CategoryEnum.Chemicals,
        },
        {
          label: intl.formatMessage({ id: "material_category_fabric" }),
          value: CategoryEnum.Fabric,
        },
      ]}
    />
  </Form.Item>
);
